<template>
  <div>
    <!-- Models modals -->
    <contact-modal v-if="keystone.config.components.modals.contact !== false"></contact-modal>
    <comment-modal v-if="keystone.config.components.modals.comment !== false"></comment-modal>
    <customer-modal v-if="keystone.config.components.modals.customer !== false"></customer-modal>
    <reminder-modal v-if="keystone.config.components.modals.reminder !== false"></reminder-modal>
    <move-reminders-modal></move-reminders-modal>
    <call-modal v-if="keystone.config.components.modals.call !== false"></call-modal>
    <task-modal></task-modal>
    <invoice-modal></invoice-modal>
    <search-customer-modal></search-customer-modal>
    <move-customers-modal></move-customers-modal>
    <merge-customers-modal></merge-customers-modal>
    <sign-proposal-modal></sign-proposal-modal>
    <email-modal></email-modal>

    <!-- Template modals -->
    <locked-modal></locked-modal>
    <impersonate-modal></impersonate-modal>
  </div>
</template>

<script>
  import LockedModal from '../Modals/LockedModal'
  import TaskModal from '../Modals/TaskModal'
  import ImpersonateModal from '../Modals/ImpersonateModal.vue'
  import ContactModal from '../Modals/ContactModal.vue'
  import CommentModal from '../Modals/CommentModal.vue'
  import CustomerModal from '../Modals/CustomerModal.vue'
  import ReminderModal from '../Modals/ReminderModal.vue'
  import InvoiceModal from '../Modals/InvoiceModal.vue'
  import CallModal from '../Modals/CallModal.vue'
  import SearchCustomerModal from "../Modals/SearchCustomerModal.vue"
  import MergeCustomersModal from "../Modals/MergeCustomersModal.vue"
  import MoveRemindersModal from "../Modals/MoveRemindersModal.vue"
  import SignProposalModal from "../Modals/SignProposalModal.vue"
  import MoveCustomersModal from "../Modals/MoveCustomersModal.vue"
  import EmailModal from "../Modals/EmailModal.vue"

  export default {
    name: 'main-modals',
    components: {
      EmailModal,
      MoveCustomersModal,
      SignProposalModal,
      MoveRemindersModal,
      MergeCustomersModal,
      SearchCustomerModal,
      CallModal,
      InvoiceModal,
      ReminderModal,
      ContactModal,
      CustomerModal,
      CommentModal,
      LockedModal,
      TaskModal,
      ImpersonateModal
    }
  }
</script>



// WEBPACK FOOTER //
// MainModals.vue?1d6236be